.rule {
  border: none;
  border-top: 1px solid var(--rule);
  margin: 0;
}

.strong {
  border-top-color: var(--rule-strong);
}
